import API from '@/services/api'
import SideBar from '@/components/SideBar.vue'
import PriceTable from '@/components/PriceTable.vue'
import ModalCloseButton from '@/components/ui/ModalCloseButton.vue'
import getLastTransaction from '@/views/home/service/getLastTransaction.js'
import getUser from '@/views/home/service/getUser.js'
import getNearPointInARange from '@/views/home/service/getNearPoint.js'
import saveBatteryStatus from '@/views/home/service/saveBatteryStatus.js'
import getCheckoutAmount from '@/views/home/service/getCheckoutAmount'
import PaymentMethodSelector from '@/components/MapNavigation/ui/PaymentMethodSelector.vue'
import setupOneSignal from './service/oneSignal.js'
import {
  TAKE_BATTERY_SUCCESS,
  TAKE_BATTERY_ERROR,
  TIMEOUTED,
  FIRMWARE_COMMUNICATION_ERROR,
  CANCELLED_BY_CUSTOMER,
  VALIDATION_ERROR,
  TAKE_BATTERY_IN_PROGRESS_STATUSES,
  TAKE_BATTERY_FAILURE_STATUSES,
  PRICE_TABLE,
  SIDE_BAR,
  FAILED_DIALOG,
  RATING_TRANSACTION,
  LAST_TRANSACTION_INFO,
  TAKE_DEMONSTRATION,
  CABLE_TYPE_LIGHTNING,
  CABLE_TYPE_MICRO,
  CABLE_TYPE_USBC,
  REFRESH_ALLOWED,
  RETURN_SUCCESS_LIST,
  PAYMENT_METHOD_CREDIT_CARD,
  PAYMENT_METHOD_PIX
} from '@/constants.js'

import '@/main.scss'
import TakeDemonstration from '@/components/TakeDemonstration.vue'
import handleError from '@/services/handleError'
import { updateCableTypeInfo } from '@/views/home/service/sendDeviceInfo'
import getPointIdFromStorage from '@/services/getPointId'
import getPointByToken from '@/services/getPointName'
import validateTerminalToken from '@/views/home/service/validateTerminalToken'
import { UserEvent, sessionRecorder, SESSION_EVENTS } from '@/services/sessionRecorder'
import TransactionInfo from '@/components/TransactionInfo.vue'
import RatingTransaction from '@/components/RatingTransaction.vue'
import ChatBot from '@/components/ChatBot.vue'
import { captureException } from '@/errors'
import visibilityObserverMixin from '@/views/home/service/visibilityObserverMixin'
import FailedDialog from '@/components/FailedDialog.vue'
import RefundSuccessModal from '@/components/RefundSuccessModal.vue'
import MapNavigation from '@/components/MapNavigation.vue'
import { isTransactionRefunded, isRefundScheduled } from '@/constants/status-constants.js'
import { BModal, BButton, BSpinner } from 'bootstrap-vue-next'
import BaseButton from '@/components/ui/BaseButton.vue'

const PIX_PAYED = 2
const PIX_PENDING = 10

const SCROLL_TIME = 500
const TOKEN_LENGTH = 4

const HOME_RETURN_FLOW_STATE_STORAGE_KEY = 'energy2go.home.returnFlowState.v1'
const HOME_LAST_TRANSACTION_ID_STORAGE_KEY = 'energy2go.home.lastTransactionId'
const LEGACY_LAST_TRANSACTION_ID_STORAGE_KEY = 'lastTransaction'

const ENABLE_CHATBOT = import.meta.env.VITE_ENABLE_CHATBOT === 'true'

export default {
  name: 'home_page',
  mixins: [visibilityObserverMixin],
  components: {
    SideBar,
    PriceTable,
    PaymentMethodSelector,
    TransactionInfo,
    RatingTransaction,
    ChatBot,
    FailedDialog,
    RefundSuccessModal,
    MapNavigation,
    BModal,
    BButton,
    BSpinner,
    BaseButton,
    ModalCloseButton,
    TakeDemonstration
  },
  props: [],
  data() {
    return {
      PRICE_TABLE,
      TAKE_BATTERY_SUCCESS,
      SIDE_BAR,
      FAILED_DIALOG,
      RATING_TRANSACTION,
      LAST_TRANSACTION_INFO,
      TAKE_DEMONSTRATION,
      CABLE_TYPE_LIGHTNING,
      CABLE_TYPE_MICRO,
      CABLE_TYPE_USBC,
      REFRESH_ALLOWED,
      ENABLE_CHATBOT,
      interval: null,
      campaign: null,
      cableType: null,
      user: null,
      plans: null,
      lastTransaction: null,
      position: null,
      takeType: 'terminal',
      batteryLevel: null,
      batteryCharging: null,
      batteryTimeRemaining: null,
      transactionId: null,
      token: '',
      infoSharing: false,
      creditCardReservationAlways: false,
      infoSharingAlways: false,
      showCreditCardRegistration: false,
      intervalId: null,
      editTokenSelection: true,
      showPriceTable: false,
      pBoxShowLink: false,
      showEvaluationTags: false,
      pointName: null,
      pointId: null,
      isFirstRequest: true,
      showSpinner: false,
      showCreditCardDeleteBox: false,
      mapArrowDown: true,
      showDemonstration: false,
      isDemonstrationLocked: false,
      totalSlots: 9,
      selectedSlot: 1,
      fingerPrintUUID: null,
      showManagePayment: false,
      pixPayed: false,
      allowEdit: true,
      persistentData: null,
      lastTransactionStatus: null,
      showRatingTransaction: false,
      showLastTransactionInfo: false,
      showBackPaymentButton: true,
      paymentMethod: null,
      signature: false,
      showChatBot: false,
      showMapNavigation: false,
      isMapModalOpen: false,
      showPriceTableModal: false,
      pointIdModal: null,
      qrTokenFromScan: null,
      showPaymentSelectorModal: false,
      showErrorModal: false,
      errorTitleModal: '',
      errorMessageModal: '',
      errorConfirmCallback: null,
      activePollingId: null,
      pollingTimeout: null,
      showRefundSuccessModal: false,
      isRefundScheduledState: true,
      isAutomaticRefund: false,
      refundPaymentMethod: null,
      refundedTransactionId: null,
      refundAmount: null,
      transactionTimestamp: null
    }
  },
  computed: {
    anyOtherModalOpen() {
      return (
        this.showPriceTableModal ||
        this.showErrorModal ||
        this.showEvaluationTags ||
        this.showRefundSuccessModal ||
        this.showRatingTransaction ||
        this.showLastTransactionInfo ||
        this.showManagePayment ||
        this.isMapModalOpen
      )
    }
  },
  unmounted() {
    this.clearPolling()
    if (this.interval) {
      clearInterval(this.interval)
    }
  },
  beforeRouteLeave(to) {
    if (!['/history', '/maps', '/home'].includes(to.path)) {
      return
    }
    this.persistentData = {
      token: this.token,
      pointName: this.pointName,
      cableType: this.cableType,
      transactionId: this.transactionId,
      paymentMethod: this.paymentMethod
    }
    localStorage.setItem('persistentData', JSON.stringify(this.persistentData))

    // Persist rent flow state so it can be restored on return
    this._persistRentFlowState()
  },
  async mounted() {
    let campaign = null
    let user = null

    try {
      campaign = sessionStorage.getItem('campaign')
      this.token = localStorage.getItem('terminal_token') || ''
      this.paymentMethod = localStorage.getItem('payment_method')
      this.pointName = localStorage.getItem('point_name')
      this.transactionId = localStorage.getItem('transaction_id')
        ? parseInt(localStorage.getItem('transaction_id'))
        : null
      this.pointId = localStorage.getItem('point_id') ? parseInt(localStorage.getItem('point_id')) : null
    } catch (error) {
      captureException(`Fail to access storage: ${error}`)
    }

    if (campaign) {
      this.campaign = campaign
    }

    if (sessionStorage.getItem('forcedRefreshLeft') === null) {
      sessionStorage.setItem('forcedRefreshLeft', REFRESH_ALLOWED)
    }

    this.fingerPrintUUID = localStorage.getItem('fingerPrintUUID')

    if (this.$route.query.closeMap === 'close') {
      this.mapArrowDown = true
    }

    try {
      user = await getUser()
      this.user = user
      if (this.user?.pix_price) {
        this.pixPrice = `${user.pix_price}`
      }
    } catch (error) {
      console.error('Failed to get user:', error)
      // If user is null and we are not authenticated, redirect to login-social
      if (!this.user) {
        if (!localStorage.getItem('token')) {
          this.$router.push('/login-social')
        } else {
          this.showErrorModal = true
          this.errorTitleModal = this.$t('error') || 'Erro'
          this.errorMessageModal =
            this.$t('network_error') || 'Não foi possível carregar os dados. Verifique sua conexão e tente novamente.'
        }
      }
      return
    }

    if (!user) {
      if (!localStorage.getItem('token')) {
        this.$router.push('/login-social')
      } else {
        this.showErrorModal = true
        this.errorTitleModal = this.$t('error') || 'Erro'
        this.errorMessageModal =
          this.$t('network_error') || 'Não foi possível carregar os dados. Verifique sua conexão e tente novamente.'
      }
      return
    }

    this.cableType = user.cable_type !== undefined ? user.cable_type : null
    this.signature = user.signature?.active

    let OneSignalDeferred = []
    try {
      OneSignalDeferred.push(() => setupOneSignal(this.user.email))
    } catch (error) {
      console.error('Failed to setup OneSignal:', error)
      captureException(`OneSignal setup failed: ${error}`)
    }

    this.loadPersistentDataFromRouting()
    this.verifyOpenPixPayment(user)

    try {
      if (this.position && this.position.lng && this.position.lat) {
        const point = await getNearPointInARange(this.position)
        if (point?.length > 0) {
          sessionStorage.setItem('point_id_geolocation', point[0].id)
        }
      }

      if (this.fingerPrintUUID) {
        saveBatteryStatus(user, this.position, this.fingerPrintUUID)
      }

      this.lastTransaction = await getLastTransaction()
      this.lastTransactionStatus = this.lastTransaction?.status || null
      console.log('[HomePage] Initial lastTransactionStatus:', this.lastTransactionStatus)

      if (this.lastTransaction?.batteryReturned) {
        const returnFlowState = this.getReturnFlowState(this.lastTransaction?.id)
        if (!returnFlowState || returnFlowState.step === 'info') {
          this.persistReturnFlowState(this.lastTransaction?.id, 'info')
          this.showLastTransactionInfo = true
          this.showRatingTransaction = false
          this.showMapNavigation = false
          this.allowEdit = false
        } else if (returnFlowState.step === 'rating') {
          this.showLastTransactionInfo = false
          this.showRatingTransaction = true
          this.showMapNavigation = false
          this.allowEdit = false
        } else if (returnFlowState.step === 'closed') {
          this.showLastTransactionInfo = false
          this.showRatingTransaction = false
        }
      }

      const POOLING_INTERVAL_TRANSACTION = 60000
      this.interval =
        setInterval(async () => {
          if (this.showEvaluationTags) return
          let lastTransaction = null
          try {
            lastTransaction = await getLastTransaction()
          } catch (error) {
            handleError('Failed to get last transaction:', error)
          }
          const isInvalidLastTransaction =
            lastTransaction == null || lastTransaction === '' || typeof lastTransaction !== 'object'

          if (isInvalidLastTransaction) {
            this.interval = null
            return
          }
          this.lastTransaction = lastTransaction
          this.lastTransactionStatus = this.lastTransaction?.status || null
        }, POOLING_INTERVAL_TRANSACTION) || null

      await this.getPointId()

      // Check transaction status from backend (persists across reloads without depending on localStorage)
      if (this.lastTransaction && this.lastTransaction.id) {
        const isRefunded = isTransactionRefunded(this.lastTransaction)
        const isFailure =
          TAKE_BATTERY_FAILURE_STATUSES.includes(this.lastTransaction.status) ||
          [
            VALIDATION_ERROR,
            TAKE_BATTERY_ERROR,
            FIRMWARE_COMMUNICATION_ERROR,
            TIMEOUTED,
            CANCELLED_BY_CUSTOMER
          ].includes(this.lastTransaction.status)
        const acknowledgedRefundId = localStorage.getItem('last_acknowledged_refund_id')

        if (isRefunded && String(acknowledgedRefundId) !== String(this.lastTransaction.id)) {
          this.showRefundSuccessModal = true
          this.isRefundScheduledState = isRefundScheduled(this.lastTransaction)
          this.refundedTransactionId = this.lastTransaction.id
          this.refundPaymentMethod = this.extractPaymentMethod(this.lastTransaction)
          this.refundAmount =
            this.lastTransaction.last_pre_payment?.refunded ||
            this.lastTransaction.last_pre_payment?.amount ||
            this.lastTransaction.payment?.amount ||
            null
          this.showEvaluationTags = false
          this.showDemonstration = false
          this.showMapNavigation = false
        } else if (isFailure && !isRefunded) {
          this.transactionId = this.lastTransaction.id
          this.cableType = this.lastTransaction.cable_type ?? this.cableType
          this.paymentMethod = this.extractPaymentMethod(this.lastTransaction)
          this.transactionTimestamp =
            this.lastTransaction.updated ||
            (this.lastTransaction.elapsed_time ? Date.now() - this.lastTransaction.elapsed_time * 1000 : null) ||
            localStorage.getItem(`evaluation_timestamp_${this.lastTransaction.id}`) ||
            null
          this.showEvaluationTags = true
          this.showDemonstration = false
          this.showMapNavigation = false
        }
      }

      // Check for persisted evaluation state fallback
      const evaluationTransactionId = localStorage.getItem('evaluation_inprogress_transaction_id')
      if (
        !this.showRefundSuccessModal &&
        evaluationTransactionId &&
        !isNaN(parseInt(evaluationTransactionId)) &&
        !this.showEvaluationTags
      ) {
        this.transactionId = parseInt(evaluationTransactionId)
        this.transactionTimestamp = localStorage.getItem(`evaluation_timestamp_${this.transactionId}`) || null
        this.showEvaluationTags = true
        this.showDemonstration = false
        this.showMapNavigation = false

        const savedCableType = localStorage.getItem('evaluation_cable_type')
        if (savedCableType !== null && !isNaN(parseInt(savedCableType))) {
          this.cableType = parseInt(savedCableType)
        }
        const savedPaymentMethod = localStorage.getItem('evaluation_payment_method')
        if (savedPaymentMethod !== null && !isNaN(parseInt(savedPaymentMethod))) {
          this.paymentMethod = parseInt(savedPaymentMethod)
        }
      }

      // Restore rent flow state if user navigated away mid-flow
      this._restoreRentFlowState()
    } catch (error) {
      captureException(error)
      console.error('Failed during final data load:', error)
    }

    // Always open the map first - it will control other states
    console.log('[HomePage] Opening map navigation check. Status:', this.lastTransactionStatus)

    // In the new unified flow, MapNavigation handles the "Active Rental" UI too.
    // We show MapNavigation if:
    // 1. It's explicitly requested (showMapNavigation is true)
    // 2. OR there is an active rental (lastTransactionStatus === TAKE_BATTERY_SUCCESS)
    // 3. OR there was a transaction error that needs handling

    const isErrorState =
      this.lastTransaction &&
      [VALIDATION_ERROR, TAKE_BATTERY_ERROR, FIRMWARE_COMMUNICATION_ERROR, TIMEOUTED, CANCELLED_BY_CUSTOMER].includes(
        this.lastTransaction.status
      )

    if (this.showEvaluationTags || this.showRefundSuccessModal) {
      this.showMapNavigation = false
    } else if (this.lastTransactionStatus === TAKE_BATTERY_SUCCESS || isErrorState) {
      this.showMapNavigation = false // This will be handled by MapNavigation internal state for active rental
    } else if (RETURN_SUCCESS_LIST.includes(this.lastTransactionStatus)) {
      // Hide map if transaction info/rating flow is showing
      if (this.showRatingTransaction || this.showLastTransactionInfo) {
        this.showMapNavigation = false
      } else {
        this.showMapNavigation = true
      }
    } else if (
      (!this.token || this.token.length < TOKEN_LENGTH) &&
      !this.showLastTransactionInfo &&
      !this.showRatingTransaction
    ) {
      // Normal flow, no token: show map
      this.showMapNavigation = true
    }

    // Check if there's a QR token from scanning a QR code
    const qrToken = sessionStorage.getItem('qr_token')
    if (qrToken) {
      console.log('[HomePage] QR token detected, passing to map:', qrToken)
      // Store the token to pass to MapNavigation
      this.qrTokenFromScan = qrToken
      // Note: MapNavigation will clear the token from sessionStorage after using it
    }

    console.log('[HomePage] Mounted finished')
  },
  watch: {
    lastTransactionStatus(newValue, oldValue) {
      if (oldValue === TAKE_BATTERY_SUCCESS && RETURN_SUCCESS_LIST.includes(newValue)) {
        console.log('Returned battery')
        this.persistReturnFlowState(this.lastTransaction?.id, 'info')
        this.showLastTransactionInfo = true
        this.showRatingTransaction = false
        this.showMapNavigation = false
        this.showDemonstration = false
        this.allowEdit = false
      }
      if (newValue === TAKE_BATTERY_SUCCESS) {
        // MapNavigation handles the checkout UI internally.
        // We set showMapNavigation to false to indicate we are in unified active rental view.
        this.showMapNavigation = false
        this.showDemonstration = false
        this.isDemonstrationLocked = true
        localStorage.removeItem('transaction_id')
        localStorage.removeItem('point_name')
        localStorage.removeItem('point_id')
      }
    },
    cableType(newValue) {
      this.cableType = newValue
      const hasNewCableType = Boolean(
        this.cableType !== null && this.cableType !== undefined && this.user.cable_type !== this.cableType
      )
      if (hasNewCableType) {
        updateCableTypeInfo(this.fingerPrintUUID, this.cableType)
        this.user.cable_type = this.cableType
      }
    },
    '$route.query.showPriceTable': {
      handler(val) {
        if (val) {
          if (!this.showPriceTableModal) {
            this.scrollToPriceTable()
          }
        }
      },
      immediate: true
    },
    async showPriceTable(newValue, oldValue) {
      if (newValue && !oldValue) {
        await this.getPointId()
        const token = localStorage.getItem('token')
        const isLoggedIn = !!token && token !== 'undefined' && token !== 'null'
        const params = {
          link_source: isLoggedIn ? 'logged' : 'not_logged'
        }
        sessionRecorder.addUserEvent(new UserEvent(SESSION_EVENTS.OPEN_PRICE_TABLE, this.transactionId, params))
        this.$nextTick(() => {
          setTimeout(() => {
            const element = this.observedMap?.get(PRICE_TABLE)
            if (element && element.scrollIntoView) {
              element.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              })
            } else {
              console.warn('Elemento não encontrado ou inválido:', element)
              const element = this.observedMap?.get(PRICE_TABLE)
              if (element) {
                this.$scrollTo(element, SCROLL_TIME, {
                  easing: 'ease'
                })
              }
            }
          }, 250)
        })
      } else if (!newValue && oldValue) {
        window.scrollTo({
          top: 0,
          behavior: 'auto'
        })
      }
    }
  },

  methods: {
    persistReturnFlowState(transactionId, step) {
      if (!transactionId || !step) {
        return
      }
      localStorage.setItem(
        HOME_RETURN_FLOW_STATE_STORAGE_KEY,
        JSON.stringify({
          transactionId,
          step
        })
      )
    },
    getReturnFlowState(transactionId) {
      try {
        const rawState = localStorage.getItem(HOME_RETURN_FLOW_STATE_STORAGE_KEY)
        if (!rawState) {
          return null
        }
        const parsedState = JSON.parse(rawState)
        if (!parsedState || parsedState.transactionId !== transactionId) {
          return null
        }
        return parsedState
      } catch (error) {
        return null
      }
    },
    closeFailedDialog() {
      // Retained as safety fallback but retry dialog cannot be dismissed without action
      this.showEvaluationTags = false
      if (this.transactionId) {
        localStorage.removeItem(`evaluation_timestamp_${this.transactionId}`)
      }
      localStorage.removeItem('evaluation_inprogress_transaction_id')
      localStorage.removeItem('evaluation_cable_type')
      localStorage.removeItem('evaluation_payment_method')
      this.transactionId = null
      this.transactionTimestamp = null
      this.showMapNavigation = true
    },
    handleRefundSuccess(payload) {
      this.clearPolling()
      this.showEvaluationTags = false
      this.transactionTimestamp = null
      this.showRefundSuccessModal = true
      this.isRefundScheduledState = true
      this.isAutomaticRefund = Boolean(payload?.isAutomatic)
      this.refundedTransactionId = payload?.transactionId || this.transactionId
      this.refundPaymentMethod = payload?.paymentMethod || this.paymentMethod
      this.showDemonstration = false
      this.showMapNavigation = false
    },
    handleCloseRefundSuccessModal() {
      this.showRefundSuccessModal = false
      if (this.refundedTransactionId) {
        localStorage.setItem('last_acknowledged_refund_id', String(this.refundedTransactionId))
      }
      localStorage.removeItem('evaluation_inprogress_transaction_id')
      localStorage.removeItem('evaluation_cable_type')
      localStorage.removeItem('evaluation_payment_method')
      this.transactionId = null
      this.showMapNavigation = true
    },
    extractPaymentMethod(transaction) {
      const method = (transaction?.payment_method || transaction?.last_pre_payment?.type || '').toLowerCase()
      if (!method) return this.paymentMethod
      return method === 'pix' ? PAYMENT_METHOD_PIX : PAYMENT_METHOD_CREDIT_CARD
    },
    async getPointId() {
      let point = null
      let pointId = null
      if (this.token?.length >= TOKEN_LENGTH) {
        point = await getPointByToken(this.token)
        pointId = point.id
      } else {
        point = getPointIdFromStorage()
        if (point.id) {
          pointId = point.id
        }
      }
      this.pointId = pointId
    },

    handleCloseLastTransactionInfo() {
      this.showLastTransactionInfo = false
      this.persistReturnFlowState(this.lastTransaction?.id, 'rating')
      if (!this.showRatingTransaction) {
        this.handleShowRatingTransaction()
      }
    },
    handleShowRatingTransaction() {
      if (this.showRatingTransaction) {
        this.allowEdit = true
        localStorage.removeItem(HOME_LAST_TRANSACTION_ID_STORAGE_KEY)
        localStorage.removeItem(LEGACY_LAST_TRANSACTION_ID_STORAGE_KEY)
        this.persistReturnFlowState(this.lastTransaction?.id, 'closed')
        this.showMapNavigation = true // Show map after rating is closed
        this.showLastTransactionInfo = false
      } else {
        this.persistReturnFlowState(this.lastTransaction?.id, 'rating')
        this.showMapNavigation = false // Hide map when rating opens
      }
      this.showRatingTransaction = !this.showRatingTransaction
    },

    async handleRetrySuccess(payload) {
      if (payload) {
        if (payload.transactionId) this.transactionId = payload.transactionId
        if (payload.selectedSlot) this.selectedSlot = payload.selectedSlot
        if (payload.totalSlots) this.totalSlots = payload.totalSlots
      }

      this.showEvaluationTags = false
      this.transactionTimestamp = null
      localStorage.removeItem('evaluation_inprogress_transaction_id')
      if (this.transactionId) {
        localStorage.removeItem(`evaluation_timestamp_${this.transactionId}`)
      }
      this.isDemonstrationLocked = false
      this.showDemonstration = true
      this.showMapNavigation = false

      if (this.transactionId) {
        this.getTransactionStatus(this.transactionId)
      }
    },
    loadPersistentDataFromRouting() {
      let persistentData = localStorage.getItem('persistentData')
      localStorage.removeItem('persistentData')
      persistentData = persistentData ? JSON.parse(persistentData) : null
      if (persistentData) {
        this.token = persistentData.token
        this.pointName = persistentData.pointName
        this.cableType = persistentData.cableType
        this.transactionId = persistentData.transactionId
        this.paymentMethod = persistentData.paymentMethod
      }
    },
    verifyOpenPixPayment(user) {
      const isLastTransactionWaitingForPixPayment = Boolean(
        user.waiting_for_pix_payment &&
        'payed' in user.waiting_for_pix_payment &&
        [PIX_PAYED, PIX_PENDING].includes(user.waiting_for_pix_payment.payed) &&
        user.waiting_for_pix_payment.transaction_id &&
        user.waiting_for_pix_payment.token &&
        user.waiting_for_pix_payment.point_name &&
        user.waiting_for_pix_payment.cable_type !== null &&
        user.waiting_for_pix_payment.cable_type !== undefined
      )
      if (isLastTransactionWaitingForPixPayment) {
        const openPixTransaction = user.waiting_for_pix_payment
        this.pixPayed = openPixTransaction.payed == PIX_PAYED ? true : false
        this.transactionId = openPixTransaction.transaction_id
        this.token = openPixTransaction.token
        this.pointName = openPixTransaction.point_name
        this.cableType = openPixTransaction.cable_type
        this.paymentMethod = PAYMENT_METHOD_PIX
      }
    },
    toggleMapNavigation() {
      // When closing the map without a token selected and cable type is selected,
      // return to cable type selection instead of closing completely
      const noToken = !this.token || this.token?.length < TOKEN_LENGTH
      const cableTypeSelected = this.cableType !== null && this.cableType !== undefined

      if (this.showMapNavigation && noToken && cableTypeSelected) {
        // Close the map and go back to cable selection
        this.showMapNavigation = false
        this.cableType = null
        this.showMapNavigation = true
      } else {
        this.showMapNavigation = !this.showMapNavigation
      }

      // Clear QR token when closing map
      if (!this.showMapNavigation) {
        this.qrTokenFromScan = null
      }
    },
    async handleMapWithdrawBattery(pointData) {
      // Prioritize cable type from pointData (from CheckoutFlowModal)
      const cableTypeToUse =
        pointData.cableType !== undefined && pointData.cableType !== null ? pointData.cableType : this.cableType

      // Update user if a newer version was provided (e.g., after credit card registration)
      if (pointData.updatedUser) {
        this.user = pointData.updatedUser
      }

      // Validate prerequisites before processing
      if (cableTypeToUse === null || cableTypeToUse === undefined) {
        console.error('[HomePage] Cannot withdraw battery: cable type not selected')
        this.showMapNavigation = false
        if (this.$refs.mapNavigationRef) {
          this.$refs.mapNavigationRef.stopValidating()
        }
        this.selectCableType()
        return
      }

      const hasValidPix = Boolean(
        this.user?.pix_identification?.name &&
        this.user?.pix_identification?.cpf_or_cnpj
      )

      if (!this.user.default_card && !hasValidPix && !this.signature) {
        this.showMapNavigation = false
        if (this.$refs.mapNavigationRef) {
          this.$refs.mapNavigationRef.stopValidating()
        }
        this.showPaymentSelectorModal = true
        return
      }

      // Update local state with selected point data
      this.token = pointData.token
      this.pointName = pointData.pointName
      this.pointId = pointData.pointId

      // Validate token
      try {
        const response = await validateTerminalToken(pointData.token, cableTypeToUse, false)

        if (response?.data?.success && response?.data?.transaction_id) {
          console.log('[HomePage] Validation success, transaction ID:', response.data.transaction_id)

          let transactionAmount = 0
          try {
            transactionAmount = await getCheckoutAmount(pointData.pointId)
          } catch (error) {
            console.warn('[HomePage] Could not resolve checkout amount:', error)
          }

          // Success - notify PointDetailsDialog
          if (this.$refs.mapNavigationRef) {
            console.log('[HomePage] Notifying MapNavigation of validation success')
            this.$refs.mapNavigationRef.notifyValidationSuccess({
              id: response.data.transaction_id,
              amount: transactionAmount
            })
          } else {
            console.error('[HomePage] mapNavigationRef is missing during validation success')
          }

          // Set transaction ID
          this.transactionId = response.data.transaction_id

          // Record analytics
          let params = {
            user_id: this.user.id,
            token: pointData.token,
            transaction_id: response.data.transaction_id
          }
          sessionRecorder.addUserEvent(new UserEvent(SESSION_EVENTS.TAKE_BATTERY, response.data.transaction_id, params))
        } else if (response?.data?.success === false) {
          // Validation failed - notify PointDetailsDialog and show error
          if (this.$refs.mapNavigationRef) {
            this.$refs.mapNavigationRef.notifyValidationError(response.data)
          }
        } else {
          // Unexpected response
          if (this.$refs.mapNavigationRef) {
            this.$refs.mapNavigationRef.notifyValidationError({
              success: false,
              error: this.$t('map_navigation.error_validating_token')
            })
          }
        }
      } catch (error) {
        console.error('[HomePage] Error validating token:', error)
        // Notify error to MapNavigation
        if (this.$refs.mapNavigationRef) {
          this.$refs.mapNavigationRef.notifyValidationError({
            success: false,
            error: error.message || this.$t('map_navigation.validation_error_generic')
          })
        }
      }
    },
    async handleMapStartRental(data) {
      // Update state for successful rental
      this.transactionId = data.transactionId
      this.selectedSlot = data.selectedSlot
      if (data.terminal) {
        this.totalSlots = data.terminal.total_slots
      }

      // Set payment method correctly
      if (data.paymentMethod === 'card') {
        this.paymentMethod = PAYMENT_METHOD_CREDIT_CARD
      } else if (data.paymentMethod === 'pix') {
        this.paymentMethod = PAYMENT_METHOD_PIX
        this.pixPayed = true
      }

      // Update cable type and other info
      this.cableType = data.cableType
      if (data.point) {
        this.token = data.point.token
        this.pointName = data.point.name
        this.pointId = data.point.point_id
      }

      if (this.cableType !== null && this.cableType !== undefined) {
        localStorage.setItem('evaluation_cable_type', this.cableType.toString())
      }
      if (this.paymentMethod !== null && this.paymentMethod !== undefined) {
        localStorage.setItem('evaluation_payment_method', this.paymentMethod.toString())
      }

      // Hide map navigation
      this.showMapNavigation = false

      // Show demonstration (battery ejecting animation)
      this.isDemonstrationLocked = false
      this.showDemonstration = true
      this.demonstrationHasError = false

      // Start polling for transaction status immediately
      this.getTransactionStatus(this.transactionId)
    },
    handleDemonstrationCancel() {
      this.clearPolling()
      this.showDemonstration = false
      this.demonstrationHasError = false
      this.showMapNavigation = true
    },
    handleStartManualCheckout(point) {
      if (!point) return

      // Set the state for manual flow
      this.token = point.token
      this.pointId = point.point_id
      this.pointName = point.name
      this.cableType = null // Reset cable type to force selection

      // Store in local storage as well to persist state
      localStorage.setItem('terminal_token', this.token)
      localStorage.setItem('point_name', this.pointName)
      localStorage.setItem('point_id', this.pointId.toString())

      // Close map and start the manual flow (cable selection first)
      this.showMapNavigation = false
      this.selectCableType(true)
    },

    handlePaymentMethodModalAdded(paymentData) {
      if (!paymentData) return
      if (paymentData.user) {
        this.user = { ...this.user, ...paymentData.user }
      }
      this.showPaymentSelectorModal = false
    },

    handleMapCheckPrices(pointData) {
      // Store the point information and token for modal
      this.token = pointData.token
      this.pointName = pointData.pointName
      this.pointId = pointData.pointId
      this.pointIdModal = pointData.pointId

      // Store token in localStorage for PriceTable component
      localStorage.setItem('terminal_token', pointData.token)

      // Open price table modal (over the map, without closing it)
      this.showPriceTableModal = true
    },
    closePriceTableModal() {
      this.showPriceTableModal = false
      this.pointIdModal = null
    },
    handleChangeCableType(newCableType) {
      // If a new cable type was selected from the error dialog, update it
      if (newCableType !== undefined && newCableType !== null) {
        console.log('[HomePage] Updating cable type from', this.cableType, 'to', newCableType)

        // Update the cable type in the component state
        this.cableType = newCableType

        // Update the user's cable type preference
        if (this.user) {
          this.user.cable_type = newCableType
        }

        // Save the new cable type to the backend
        if (this.fingerPrintUUID) {
          updateCableTypeInfo(this.fingerPrintUUID, newCableType)
        }

        // Force Vue to complete the update before returning
        // This ensures MapNavigation will see the updated cableType when it retries
        this.$nextTick(() => {
          console.log('[HomePage] Cable type update completed, cableType is now:', this.cableType)
        })

        // Keep the map open and let the user retry with the new cable type
        // The MapNavigation component will handle re-validation
        return
      }

      // If no cable type provided (old behavior), close map and go back to cable selection
      this.showMapNavigation = false
      this.selectCableType()
    },
    async scrollToPriceTable(onlyClose = false) {
      if (onlyClose) {
        this.showPriceTableModal = false
        this.pointIdModal = null
        // Clear query param using replace so as not to clutter the history
        if (this.$route.query.showPriceTable) {
          const newQuery = { ...this.$route.query }
          delete newQuery.showPriceTable
          this.$router.replace({ query: newQuery }).catch(() => {})
        }
        return
      }

      // If we are opening (toggle to true)
      if (!this.showPriceTableModal) {
        this.showPriceTableModal = true

        // If we don't have a point selected, try to get the current one from storage
        if (!this.pointIdModal) {
          const point = getPointIdFromStorage()
          if (point && point.id) {
            this.pointIdModal = point.id
          }
        }
      } else {
        // If we were already open and toggling (calling from menu again?)
        // Toggle off
        this.showPriceTableModal = false
        this.pointIdModal = null

        if (this.$route.query.showPriceTable) {
          const newQuery = { ...this.$route.query }
          delete newQuery.showPriceTable
          this.$router.replace({ query: newQuery }).catch(() => {})
        }
      }
    },

    clearPolling() {
      if (this.pollingTimeout) {
        clearTimeout(this.pollingTimeout)
        this.pollingTimeout = null
      }
      this.activePollingId = null
    },

    handleTakeBatteryFailure(id, status, error = null) {
      this.clearPolling()
      this.transactionId = id
      this.showDemonstration = false
      this.showMapNavigation = false
      this.showEvaluationTags = true
      this.lastTransactionStatus = status

      const now = Date.now()
      this.transactionTimestamp = now
      localStorage.setItem('evaluation_inprogress_transaction_id', id.toString())
      localStorage.setItem(`evaluation_timestamp_${id}`, now.toString())
      if (this.cableType !== null && this.cableType !== undefined) {
        localStorage.setItem('evaluation_cable_type', this.cableType.toString())
      }
      if (this.paymentMethod !== null && this.paymentMethod !== undefined) {
        localStorage.setItem('evaluation_payment_method', this.paymentMethod.toString())
      }

      sessionRecorder.addUserEvent(
        new UserEvent(SESSION_EVENTS.TAKE_BATTERY_ERROR, id, {
          cable_type: this.cableType,
          error: error || status
        })
      )
    },

    getTransactionStatus: async function (id, isRecursive = false, attempt = 1) {
      // Prevent multiple polling loops for the same transaction
      if (!isRecursive) {
        if (this.activePollingId === id) {
          console.log('[HomePage] Polling already active for transaction:', id)
          return
        }
        this.clearPolling()
        this.activePollingId = id
      } else if (this.activePollingId !== id) {
        console.log('[HomePage] Polling cancelled or changed for transaction:', id)
        return
      }

      const MAX_POLLING_ATTEMPTS = 20
      if (attempt > MAX_POLLING_ATTEMPTS) {
        console.warn('[HomePage] Max polling attempts reached for transaction:', id)
        this.handleTakeBatteryFailure(id, TIMEOUTED, 'polling_timeout')
        return
      }

      try {
        const response = await API.get('transaction/status/' + id)

        if (this.activePollingId !== id) {
          return
        }

        if (!response || !response.data) {
          this.handleTakeBatteryFailure(id, TAKE_BATTERY_ERROR, 'empty_response')
          return
        }

        const status = response.data.status
        const isTakeError =
          TAKE_BATTERY_FAILURE_STATUSES.includes(status) ||
          Boolean(response.data.timeouted) ||
          response.data.success === false ||
          (!response.data.success && Boolean(response.data.error)) ||
          (!TAKE_BATTERY_IN_PROGRESS_STATUSES.includes(status) && status !== TAKE_BATTERY_SUCCESS)

        if (isTakeError) {
          const errorStatus = status || (response.data.timeouted ? TIMEOUTED : TAKE_BATTERY_ERROR)
          this.handleTakeBatteryFailure(id, errorStatus, response.data.error || errorStatus)
          return
        }

        if (status === TAKE_BATTERY_SUCCESS) {
          this.clearPolling()
          this.showDemonstration = false
          this.isDemonstrationLocked = true
          this.handleTakeBatterySuccess()
          sessionRecorder.addUserEvent(
            new UserEvent(SESSION_EVENTS.TAKE_BATTERY_SUCCESS, id, {
              cable_type: this.cableType
            })
          )
          return
        }

        const POOLING_INTERVAL_STATUS = 3000
        this.pollingTimeout = setTimeout(async () => {
          await this.getTransactionStatus(id, true, attempt + 1)
        }, POOLING_INTERVAL_STATUS)
      } catch (error) {
        console.error('[HomePage] Error getting transaction status:', error)
        this.handleTakeBatteryFailure(id, TAKE_BATTERY_ERROR, error)
      }
    },
    async handleTakeBatterySuccess() {
      this.clearPolling()
      this.lastTransaction = await getLastTransaction()
      this.showDemonstration = false
      this.isDemonstrationLocked = true
      this.lastTransactionStatus = this.lastTransaction?.status
    },
    toggleChatBot() {
      this.showChatBot = !this.showChatBot
    },
    handleErrorModalConfirm() {
      this.showErrorModal = false
      if (this.errorConfirmCallback) {
        this.errorConfirmCallback()
      }
    },
    _persistRentFlowState() {
      const flowState = {
        showDemonstration: this.showDemonstration,
        showMapNavigation: this.showMapNavigation,
        selectedSlot: this.selectedSlot,
        totalSlots: this.totalSlots,
        showEvaluationTags: this.showEvaluationTags,
        lastTransactionStatus: this.lastTransactionStatus,
        pixPayed: this.pixPayed
      }
      localStorage.setItem('rentFlowState', JSON.stringify(flowState))
    },
    _restoreRentFlowState() {
      try {
        const stored = localStorage.getItem('rentFlowState')
        if (!stored) return
        const state = JSON.parse(stored)

        // Only restore if we have an active transaction
        if (!this.transactionId) {
          localStorage.removeItem('rentFlowState')
          return
        }

        // Don't restore if the rental is already complete
        if (state.lastTransactionStatus === TAKE_BATTERY_SUCCESS) {
          localStorage.removeItem('rentFlowState')
          return
        }

        console.log('[HomePage] Restoring rent flow state:', state)

        if (state.showDemonstration) {
          this.showDemonstration = true
          this.showMapNavigation = false
          this.selectedSlot = state.selectedSlot
          this.totalSlots = state.totalSlots
        } else if (state.showEvaluationTags) {
          this.showEvaluationTags = true
          this.showDemonstration = false
        } else if (state.showMapNavigation) {
          this.showMapNavigation = true
        }

        if (state.pixPayed) {
          this.pixPayed = true
        }

        // If we have a transactionId but no UI state and no success,
        // the user was likely mid-payment or mid-polling.
        // Start polling to check status.
        if (
          !this.showDemonstration &&
          !this.showEvaluationTags &&
          !this.showMapNavigation &&
          this.lastTransactionStatus !== TAKE_BATTERY_SUCCESS
        ) {
          console.log('[HomePage] Transaction exists but no UI state restored, polling for status')
          this.getTransactionStatus(this.transactionId)
        }

        // Clear persisted state after restoring
        localStorage.removeItem('rentFlowState')
      } catch (error) {
        console.error('[HomePage] Failed to restore rent flow state:', error)
        localStorage.removeItem('rentFlowState')
      }
    }
  }
}
